import { CertificacionI } from "interfaces/Certificacion";
import { ReactNode } from "react";

interface Props {
  elemento: CertificacionI;
  renderActions?: (elemento: CertificacionI) => ReactNode;
}

export const CertificacionesRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`CertificacionesTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        <td>{elemento.descripcion}</td>
        {renderActions && <td>{renderActions(elemento)}</td>}
      </tr>
    </>
  );
};
